export default "//cloud.imgsmail.ru/cloud.mail.ru/141861/img/build/welcome/welcomeDialogNewCover.jpg";